import { useState } from 'react';
import { Play } from 'lucide-react';

interface LazyYouTubeProps {
  videoId: string;
  title: string;
  className?: string;
}

const LazyYouTube = ({ videoId, title, className = '' }: LazyYouTubeProps) => {
  const [isLoaded, setIsLoaded] = useState(false);

  // mqdefault (320x180) is ~70KB vs maxresdefault (~200KB+) — much faster on mobile
  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;

  if (isLoaded) {
    return (
      <iframe
        src={`https://www.youtube-nocookie.com/embed/${videoId}?rel=0&modestbranding=1&autoplay=1`}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className={className}
      />
    );
  }

  return (
    <button
      onClick={() => setIsLoaded(true)}
      className={`group relative cursor-pointer bg-muted ${className}`}
      aria-label={`Reproduzir ${title}`}
    >
      <img
        src={thumbnailUrl}
        alt={title}
        loading="lazy"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 flex items-center justify-center bg-foreground/20 group-hover:bg-foreground/30 transition-colors">
        <div className="w-16 h-16 rounded-full bg-primary flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
          <Play className="w-7 h-7 text-primary-foreground ml-1" fill="currentColor" />
        </div>
      </div>
    </button>
  );
};

export default LazyYouTube;
